/*! bxs-vue-ui v4.0.1 */
import { y as userAgent, _ as _export, k as global_1, N as path } from './es.array.join.js';
import { c as create, n as normalizeComponent } from './normalize-component.js';
import { f as forEach } from './index.js';
import Vue from 'vue';
import { _ as _extends } from './extends.js';
import __vue_component__$1 from '../icon/index.js';

var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check

var wrap = function (scheduler) {
  return function (handler, timeout /* , ...arguments */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : undefined;
    return scheduler(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof handler == 'function' ? handler : Function(handler)).apply(this, args);
    } : handler, timeout);
  };
};

// ie9- setTimeout & setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
_export({ global: true, bind: true, forced: MSIE }, {
  // `setTimeout` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
  setTimeout: wrap(global_1.setTimeout),
  // `setInterval` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
  setInterval: wrap(global_1.setInterval)
});

var setTimeout = path.setTimeout;

var setTimeout$1 = setTimeout;

var _components;
var script = create({
  name: 'toast',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  components: (_components = {}, _components[__vue_component__$1.name] = __vue_component__$1, _components)
});

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('transition', {
    attrs: {
      "name": "bx-animate-fade"
    }
  }, [_vm.visible ? _c('div', {
    staticClass: "bx-toast"
  }, [_c('div', {
    staticClass: "bx-toast-inner",
    class: _vm.icon && 'bx-toast-block'
  }, [_vm.icon ? _c('bxs-icon', {
    staticClass: "bx-toast-icon",
    attrs: {
      "name": _vm.icon
    }
  }) : _vm._e(), _c('span', {
    staticClass: "bx-toast-text"
  }, [_vm._v("\n        " + _vm._s(_vm.message) + "\n      ")])], 1)]) : _vm._e()]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

var _context;
var ToastConstructor = Vue.extend(__vue_component__);
var theInstance;

var getInstance = function getInstance() {
  if (!theInstance) {
    theInstance = new ToastConstructor({
      el: document.createElement('div')
    });
  }

  return theInstance;
};

var appendDom = function appendDom(el) {
  if (!el.parentNode) {
    document.body.appendChild(el);
  }
};

var removeDom = function removeDom(event) {
  if (event.target.parentNode) {
    event.target.parentNode.removeChild(event.target);
  }
};

ToastConstructor.prototype.close = function close() {
  this.visible = false;
  this.$el.addEventListener('transitionend', removeDom);
};

function Toast(options) {
  if (options === void 0) {
    options = {};
  }

  var duration = options.duration || 2000;
  var instance = getInstance();
  clearTimeout(instance.timer);
  instance.$el.removeEventListener('transitionend', removeDom);
  instance.message = typeof options === 'string' ? options : options.message;
  instance.type = options.type || '';
  instance.icon = options.icon || '';

  if (!instance.icon) {
    switch (instance.type) {
      case 'success':
        instance.icon = 'check-plain';
        break;

      case 'fail':
        instance.icon = 'close-plain';
        break;

      case 'warning':
        instance.icon = 'warning-plain';
        break;

      default:
        instance.icon = '';
    }
  }

  appendDom(instance.$el);
  Vue.nextTick(function () {
    instance.visible = true;

    if (duration) {
      instance.timer = setTimeout$1(function () {
        instance.close();
      }, duration);
    }
  });
  return instance;
}

forEach(_context = ['success', 'fail', 'warning']).call(_context, function (method) {
  Toast[method] = function (options) {
    if (options === void 0) {
      options = {};
    }

    var opt = {
      type: method
    };

    if (typeof options === 'string') {
      opt.message = options;
    } else {
      opt = _extends(opt, options);
    }

    Toast(opt);
  };
});

Toast.install = function (vueGlobal) {
  /* eslint no-param-reassign: ["error", { "props": false }] */
  vueGlobal.use(__vue_component__);
  vueGlobal.prototype.$toast = Toast;
};

export { Toast as T, setTimeout$1 as s };
